import { START_DATE, START_OPTION, START_OPTION_NOW } from '../../../../ReusableFormFields/StartTimeFields/fields'
import { stopTimeInitialValues } from '../../../../ReusableFormFields/StopTimeFields/fields'
import { frequencyFields } from '../../../fields'

export const NAME = 'name'
// campaign type
export const CAMPAIGN_TYPE = 'campaignType'
export const DISPLAY_OR_VIDEO_CAMPAIGN_TYPE = 'displayOrVideoCampaignType'
export const YOUTUBE_CAMPAIGN_TYPE = 'youtubeCampaignType'
export const AUDIO_CAMPAIGN_TYPE = 'audioCampaignType'
// goal type
export const PERFORMANCE_GOAL_TYPE = 'performance_goal_type'
export const PERFORMANCE_GOAL_AMOUNT = 'performance_goal_amount'
export const PERFORMANCE_GOAL_TYPE_CPA = 'PERFORMANCE_GOAL_TYPE_CPA'
export const PERFORMANCE_GOAL_TYPE_CPM = 'PERFORMANCE_GOAL_TYPE_CPM'
export const PERFORMANCE_GOAL_TYPE_CPIAVC = 'PERFORMANCE_GOAL_TYPE_CPIAVC'
export const PERFORMANCE_GOAL_TYPE_VCPM = 'PERFORMANCE_GOAL_TYPE_VCPM'
export const PERFORMANCE_GOAL_TYPE_CPC = 'PERFORMANCE_GOAL_TYPE_CPC'
export const PERFORMANCE_GOAL_TYPE_CTR = 'PERFORMANCE_GOAL_TYPE_CTR'
export const PERFORMANCE_GOAL_TYPE_VIEWABILITY = 'PERFORMANCE_GOAL_TYPE_VIEWABILITY'
export const PERFORMANCE_GOAL_TYPE_CLICK_CVR = 'PERFORMANCE_GOAL_TYPE_CLICK_CVR'
export const PERFORMANCE_GOAL_TYPE_IMPRESSION_CVR = 'PERFORMANCE_GOAL_TYPE_IMPRESSION_CVR'
export const PERFORMANCE_GOAL_TYPE_VTR = 'PERFORMANCE_GOAL_TYPE_VTR'
export const PERFORMANCE_GOAL_TYPE_CPV = 'PERFORMANCE_GOAL_TYPE_CPV'
export const PERFORMANCE_GOAL_TYPE_AUDIO_COMPLETION_RATE = 'PERFORMANCE_GOAL_TYPE_AUDIO_COMPLETION_RATE'
export const PERFORMANCE_GOAL_TYPE_VIDEO_COMPLETION_RATE = 'PERFORMANCE_GOAL_TYPE_VIDEO_COMPLETION_RATE'
// budget lifetime
export const PLANNED_SPEND_AMOUNT = 'planned_spend_amount'
export const OBJECTIVE_AMOUNT = 'objective_amount'
export const OBJECTIVE_PERCENTAGE = 'objective_percentage'
// bidCap
export const BID_CAP = 'bid_cap'

export const getInitialValues = minStartDate => {
  return {
    [NAME]: '',
    [CAMPAIGN_TYPE]: DISPLAY_OR_VIDEO_CAMPAIGN_TYPE,
    [PERFORMANCE_GOAL_TYPE]: PERFORMANCE_GOAL_TYPE_CPA,
    [PLANNED_SPEND_AMOUNT]: '',
    [BID_CAP]: '',
    // line item start time
    [START_OPTION]: START_OPTION_NOW,
    [START_DATE]: new Date(minStartDate),
    // line item stop time
    ...stopTimeInitialValues,
    ...frequencyFields
  }
}
